const app_url =  process.env.REACT_APP_PROJECT_URL
const model_url = process.env.REACT_APP_MODEL_URL
const API_URL = process.env.REACT_APP_API_URL + "/chat"
export {
    app_url,
    model_url,
    API_URL
}